import { connect } from 'react-redux';
import FilterContainer from './filter-container';
import {
  loadLocationsAction,
  loadAllReportData,
} from '../../reducers/reports.reducers';


const mapStateToProps = state => ({
  filters: state.reports.filters,
});

const mapDispatchToProps = dispatch => ({
  loadAllReportData: () => dispatch(loadAllReportData()),
});

export default connect(mapStateToProps, mapDispatchToProps)(FilterContainer);
